/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { DashboardSection } from '../dashboard';
import { CustomReport } from '../../types/custom-report';
import CustomReportEditForm from './CustomReportEditForm';
import CustomReportMetricsList from './CustomReportMetricsList';
import './styles.scss';

interface CustomReportsEditProps {
  customReport?: CustomReport;
  handleReload: () => Promise<void>;
}

const CustomReportManage = (props: CustomReportsEditProps) => {
  const { customReport, handleReload } = props;

  return (
    <>
      <DashboardSection
        headingStyle={4}
        title={'Calculated report builder'}
      >
        <div className='mt-4'>
          <CustomReportEditForm customReport={customReport} />
        </div>

        <div className='mt-5'>
          <hr />

          <div className='mt-4 strong'>Metrics in this report</div>

          <div className='mt-3'>
            <CustomReportMetricsList customReport={customReport} handleReload={handleReload} />
          </div>
        </div>
      </DashboardSection>
    </>
  )
}

export default CustomReportManage;
